/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class RadiusField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Minimum Radius</label>
        <Input
          label={{ content: 'meter' }}
          labelPosition="right"
          placeholder="e.g 5000"
          type="number"
          min="0"
          required
          onChange={e => onChange('radius', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/radiusField.js